export default __webpack_public_path__ + "static/media/RedoIcon.692370c1.svg";